import React from 'react';
import { Box, Button, Typography } from '@mui/material';

type Props = {
    summary: string;
    handleClose: () => void;
}

const NotificationSummary = ({ summary, handleClose }: Props) => {
    return (
        <Box>
            <Typography
                variant="h5"
                sx={{
                    marginBottom: '16px',
                    color: '#101828',
                    fontWeight: 700,
                }}
            >
                Summary
            </Typography>

            <Box
                sx={{
                    padding: '20px',
                    border: '1px solid #e4e7ec',
                    borderRadius: '14px',
                    backgroundColor: '#f9fafb',
                }}
            >
                <Typography
                    sx={{
                        color: '#475467',
                        fontSize: '16px',
                        lineHeight: 1.7,
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {summary}
                </Typography>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '24px',
                }}
            >
                <Button
                    variant="contained"
                    onClick={handleClose}
                    sx={{
                        minWidth: '110px',
                        padding: '10px 24px',
                        borderRadius: '10px',
                        textTransform: 'none',
                        fontWeight: 600,
                    }}
                >
                    Close
                </Button>
            </Box>
        </Box>
    );
};

export default NotificationSummary;